import appApi from '../../../../../../../api/app-api';
import { toast } from 'react-toastify';
import { FileUploadFile } from 'primereact/fileupload';
import { HttpStatusCode } from 'axios';
import globalConfigStore from '../../../../../../../stores/global-config-store';

export const uploadContractFileOperation = async (
  branchId: number,
  userId: number,
  rateId: number,
  isSignContract: boolean,
  file: FileUploadFile | undefined,
) => {
  try {
    if (!file) {
      toast.warn('יש להעלות קובץ');
      return;
    }

    const fileType = file.name.split('.').pop();
    const res = await appApi.getContractPreSignUrl(
      branchId,
      userId,
      rateId,
      fileType,
      isSignContract,
    );

    const fileUrl = res.data.body.fileUrl;

    const urlWithoutQueryParams = fileUrl.split('?')[0];

    // Use the URL object to extract just the path
    const parsedUrl = new URL(urlWithoutQueryParams);
    const path = parsedUrl.pathname;

    const fullUrl = `${globalConfigStore.baseFileUrl}${path}`;

    const uploadFileRes = await appApi.uploadFile(fileUrl, file);
    if (uploadFileRes.status !== HttpStatusCode.Ok) {
      throw new Error('Upload file is failed');
      toast.error('העלאת הקובץ נכשלה, יש לנסות שוב בעוד מספר רגעים...');
    }

    const uploadFileUrl = await appApi.uploadContract(
      branchId,
      userId,
      rateId,
      fullUrl,
    );
    console.log(`XXX data res1: ${fullUrl}`);
    console.log(`XXX data res2: ${uploadFileRes}`);
  } catch (e) {
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `uploadContractFileOperation is failed with the branchId: ${branchId}, userId: ${userId}, rateId: ${rateId}, isSignContract: ${isSignContract} with the error: ${e}`,
    );
  }
};
